export class PolicyResult {
    public isError: boolean;
    public roles: Array<string>;
    public permissions: Array<string>;
}
